import styled from 'styled-components';

export const AddUnitsToCourseContainer = styled.div`
  .container-unit {
    flex-shrink: 0;
    width: 69.75rem;
    margin: 1.5rem 0rem 0rem 0;

    @media (max-width: 69.75rem) {
      & {
        width: 98%;
      }
    }
  }
  .courseheading {
    display: flex;
    flex-direction: column;
    .main-text {
      color: #3d4457;
      font-weight: 500;
      font-size: 1.25rem;
      margin-bottom: 0.5rem;
    }
  }
  .code {
    font-size: 0.875rem;
    color: #8a8c94;
    margin-top: 0.5rem;
  }
  .custombox {
    min-height: 13.5rem;
  }
  .row-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    width: 100%;

    .save-changes {
      border: 0.0625rem solid #40a1ff;
      border-radius: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        vertical-align: middle;
        margin-right: 0.5rem;
      }
      .add-button-text {
        color: #40a1ff;
        font-family: Inter;
        font-style: normal;
        font-weight: 500;
        font-size: 0.875rem;
        margin-top: 0.1rem;
      }
    }

    .field-left {
      width: 53%;
      margin-right: 1rem;
    }
    .field-middle {
      width: 20%;
      margin-right: 1rem;
    }
    .field-right {
      width: 9%;
      margin-top: 1.5rem;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type='number'] {
      -moz-appearance: textfield;
    }

    @media (max-width: 50rem) {
      & {
        display: flex;
        flex-direction: column;
      }
      .field-left {
        width: 100%;
        margin: unset;
      }
      .field-middle {
        width: 100%;
        margin-top: 1rem;
        margin-right: unset;
      }
      .field-right {
        width: 100%;
        margin-top: 1rem;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
`;

export const ManualTableStyles = styled.div`
  background-color: #fff;
  box-shadow: unset;
  padding: 1.5rem 0 0 0;
  width: 100%;

  table {
    margin-top: 1rem;
    width: 100%;

    td:last-child {
      width: 100%;
    }

    .serial {
      width: 5%;
    }

    .unit-code {
      width: 10%;
    }
    .unit-name {
      width: 52%;
    }

    .sessions {
      width: 15%;
    }
    .hours {
      width: 15%;
    }

    .close-row {
      width: 8%;
    }

    .closeIconBtn {
      display: block;
      border: none;
      background: transparent;
      outline: none;
    }
  }
`;
